import { getProfileUser, impersonationApi } from './services';
import { UserDataSlice } from './reducer';
import { RETCODE_SUCCESS, RETTEXT_SUCCESS } from '@configs/contants';
/*Api*/
import apiMethod from '@utility/api_method';

export const {
  setUserData,
  setUserLoading,
  setUserError,
  setImpersonationData,
  setIsImpersonationData,
} = UserDataSlice.actions;

export const onSetUserData = (userInfo) => async (dispatch) => {
  try {
    setUserLoading(true);
    dispatch(setUserData(userInfo));
  } catch (err) {
    dispatch(setUserError(err));
    throw new Error(err);
  } finally {
    dispatch(setUserLoading(true));
  }
};

export const onGetProfileUser = (id) => async (dispatch) => {
  try {
    setUserLoading(true);
    const res = await getProfileUser({ id });
    if (res.retCode !== RETCODE_SUCCESS) {
      return;
    }
    if (!!res.data) {
      dispatch(setUserData(res.data));
    }
  } catch (err) {
    dispatch(setUserError(err));
    throw new Error(err);
  } finally {
    dispatch(setUserLoading(true));
  }
};

export const onImpersonation = (eventId) => async (dispatch) => {
  try {
    setUserLoading(true);
    const res = await impersonationApi(eventId);
    if (res.retCode !== RETCODE_SUCCESS) {
      return;
    }

    if (!!res.data) {
      const accessToken = res.data?.token;
      if (accessToken) {
        apiMethod.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      }
      localStorage.setItem('impersonationToken', accessToken);
      localStorage.setItem('isImpersonation', true);
      localStorage.setItem('eventId', res?.data?.eventId);
      dispatch(setImpersonationData(res.data));
      dispatch(setIsImpersonationData(true));
    }
  } catch (err) {
    dispatch(setUserError(err));
    throw new Error(err);
  } finally {
    dispatch(setUserLoading(true));
    setTimeout(() => window.location.replace('/'), 500);
  }
};

export const onImpersonationOut = () => async (dispatch) => {
  try {
    setUserLoading(true);
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      apiMethod.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }
    localStorage.removeItem('impersonationToken');
    localStorage.removeItem('isImpersonation');
    localStorage.removeItem('eventId');
    dispatch(setIsImpersonationData(false));
    dispatch(setImpersonationData(undefined));
  } catch (err) {
    dispatch(setUserError(err));
    throw new Error(err);
  } finally {
    dispatch(setUserLoading(true));
    setTimeout(() => window.location.replace('/'), 500);
  }
};

export default UserDataSlice.reducer;
